import dashboardService from './dashboardService';

export default {
    inheritAttrs: false,
    props: {
        instanceId: { type: String, required: true },
    },
    computed: {
        instance() {
            return dashboardService.getInstance(this.instanceId);
        },
        config() {
            return this.instance?.config || {};
        },
        apiData() {
            return dashboardService.getWidgetData(this.instanceId);
        },
        loading() {
            return dashboardService.isWidgetLoading(this.instanceId) && !this.apiData;
        },
    },
    methods: {
        providerName(code) {
            const target = code || this.config?.provider;
            if (!target) return '';
            try {
                const modules = JSON.parse(localStorage.getItem('company_modules') || '[]');
                return modules.find(m => m.code === target)?.name || target;
            } catch {
                return target;
            }
        },
    },
};
